import { useMutation } from '@tanstack/react-query';
import { submitLeadCapture } from '../services/leadCapture';

interface LeadCaptureResponse {
  id: string;
  errors: Array<unknown>;
  success: boolean;
}

export const useSubmitLeadCapture = (
  sessionId: string,
  options?: {
    onSuccess?: (data: LeadCaptureResponse) => void;
    onError?: (error: Error) => void;
  }
) => {
  const { mutate: submitLead, isPending } = useMutation({
    mutationFn: (payload: Record<string, unknown>) => submitLeadCapture(sessionId, payload),
    onSuccess: (data: LeadCaptureResponse) => options?.onSuccess?.(data),
    onError: (error: Error) => options?.onError?.(error),
  });

  return { submitLead, isPending };
};
